import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-icon-placeholder",
  templateUrl: "./button-icon-placeholder.component.html",
  styleUrls: ["./button-icon-placeholder.component.scss"],
})
export class ButtonIconPlaceholderComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService
  ) {}

  mediaform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() config: any;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;
  currentMenuSubscription: any;
  colorsComponentSubscription: any;
  valueChangesSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_text: string;
  row_id: string;
  labelColor: string;
  black_color: string = "#000000";
  enableCustomColor: boolean = false;
  enableCustomGradientColor: boolean = false;

  button_label_color: string;
  button_label_style: any;
  button_button_divider: number;

  data: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  modalRef?: BsModalRef;
  icon: any;
  placeholder_icon: any;
  iconType: number;
  fontSize = "md";
  density = 0;
  textAlign = "left";
  isAndroid: boolean;
  light: boolean;
  text_id: any;
  colors: any;
  labelDarkColor: any;
  button_color_item: any = { schemes: { light: {}, dark: {} } };
  button_color_light: any = {};
  button_color_dark: any = {};
  sync = true;
  os_name: string;
  fontID: string;
  alginID: string;
  densityID: string;

  startColor: string;
  startDarkColor: string;
  endColor: string;
  endDarkColor: string;
  divider: number;
  colorObject: any;
  selectedColor;
  enableBg: boolean;

  sourcesList = [
    { name: "Camera", key: "camera" },
    { name: "Gallery", key: "gallery" },
  ];

  enableMultiple = false;
  enableCompression = false;
  enableBase64 = false;

  ngOnInit() {
    this.field_id = this.config.id;
    this.fontID = this.mdw.makeRef(16);
    this.densityID = this.mdw.makeRef(16);
    this.alginID = this.mdw.makeRef(16);
    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.light = data.light;
        }
      });
  }

  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.field_id = this.config.id;
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

      if (this.button.button_icon_placeholder) {
        this.placeholder_icon = this.builderService.getIcon(
          this.button.button_icon_placeholder
        );
      }
    }
  }

  openSelector(exlargeModal: any) {
    this.modalRef = this.modalService.show(exlargeModal, { class: "modal-xl" });
  }

  iconChange(event) {
    if (event) {
      this.placeholder_icon = this.builderService.getIcon(event);

      this.button.button_icon_placeholder = event;

      this.updateButtonData();
      this.modalRef.hide();
    }
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
}
